export default {
    title: "Thank you",
    content:
        "In the next few hours, we will contact you through WhatsApp, e-mail, or call. Do you want to contact our agents? Go to WhatsApp",
    btn1: "Contact us via whatsapp",
    btn2: "Visit noritex.com",
    btn3: "Visit Showroom",
    ws_text: "Hello, I would like to know more about the home decor show",
};
